<template>
  <div  class="embed-conteudo has-text-centered" v-if='data' style="margin-top:30px;">
    <div class="title is-6 has-text-weight-bold"> Imagem</div>
    <div class="subtitle is-6">
      Adicionar imagem ao curso causa uma ótima impressão para os possíveis inscritos. <br />
      Além do mais, ela aparecerá na pagina principal. <i>Faça uma boa escolha!</i>
    </div>
    <div class="has-text-centered">
     <el-upload
        class="avatar-uploader"
        :action="`${base}/api/admin/curso/${curso_id}/upload`"
        :headers='{"authorization": `Bearer ${jwt}`}'
        :show-file-list="false"
        :on-success="handleAvatarSuccess"
        :before-upload="beforeAvatarUpload">
        <img v-if="data.imagem_original" :src='image_path(data)' class="avatar">
        <i v-if="data.imagem_original" >*clique para mudar a imagem</i>
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
    </div>
  </div>  
</template>

<script>
  export default {
    props: ['data'],
    data() {
      return {
        imageUrl: ''
      };
    },
    computed: {
      base(){
        console.log(window.base)
        return window.base
      },
      curso_id() {
        return this.$route.params.curso;
      },
      jwt(){
        return this.$store.state.session.jwt;
      }
    },
    methods: {
      image_path(c){
        if(c.imagem_original)
          return `${global.base}/${c.imagem_original}`
        return false
      },
      handleAvatarSuccess(res, file) {
        this.imageUrl = URL.createObjectURL(file.raw);
        this.data.imagem_original = res.imagem_original;
        this.data.imagem_thumb = res.imagem_thumb;
        console.log(this.data)
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isPNG = file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 8;

        if (!isJPG && !isPNG) {
          this.$message.error('As imagems devem ser JPG ou PNG');
        }
        if (!isLt2M) {
          this.$message.error('Imagem não pode exceder 8MB!');
        }
        return (isJPG && isLt2M) || (isPNG && isLt2M);
      },
      
    }
  };
</script>

<style>
  .embed-conteudo{

  } 
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width:  178px;
    padding-top:70px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 300px;
    height: 178px;
    display: block;
  }
</style>